// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdminCallInfoGroup_wrapper__E4sYh","fields":"AdminCallInfoGroup_fields__2py6_"};